const MAP = {
  draft: { label: "Draft", cls: "bg-secondary text-secondary-foreground border border-border" },
  approved: { label: "Approved", cls: "bg-accent/15 text-accent border border-accent/30" },
  scheduled: { label: "Scheduled", cls: "bg-blue-500/15 text-blue-600 border border-blue-500/30" },
  published: { label: "Published", cls: "bg-accent text-accent-foreground" },
  failed: { label: "Failed", cls: "bg-destructive/15 text-destructive border border-destructive/30" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      {s.label}
    </span>
  );
}

const PLATFORM_COLORS = {
  instagram: "text-pink-600 bg-pink-500/10",
  tiktok: "text-foreground bg-foreground/10",
  facebook: "text-blue-600 bg-blue-500/10",
  linkedin: "text-sky-700 bg-sky-500/10",
};

export function PlatformTag({ platform }) {
  const cls = PLATFORM_COLORS[platform] || "text-muted-foreground bg-secondary";
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium capitalize ${cls}`}>
      {platform}
    </span>
  );
}
